import { render } from "./ReservationInfos.vue?vue&type=template&id=6a8cad9c&scoped=true"
import script from "./ReservationInfos.vue?vue&type=script&lang=js"
export * from "./ReservationInfos.vue?vue&type=script&lang=js"

import "./ReservationInfos.vue?vue&type=style&index=0&id=6a8cad9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8cad9c"]])

export default __exports__